The opaque cursor to advertisement branding.

This can be used as a subsequent pagination argument.
